<script>
import { mapState } from 'vuex';
import ContactForm from '../../components/contactForm.vue';

export default {
    name: "museum",
    data() {
        return {};
    },
    computed: {
        ...mapState(['talentMuseum']),
    },
    components: {
        ContactForm
    },
    mounted() {
        this.$store.dispatch('getTalentMuseum');
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="museum">
        <div class="layout_main">
            <!-- banner -->
            <div class="content banner">
                <div class="layout_bg bg" :style="`background-image: url(${ talentMuseum.image });`"></div>
                <div class="text text_shadow">
                    <p class="name">{{ talentMuseum.name }}</p>
                    <p class="en_name">{{ talentMuseum.en_name }}</p>
                </div>
            </div>
            <!-- 关于品牌 -->
            <div class="content about flex align_center">
                <div class="cover">
                    <div class="layout_bg bg" :style="`background-image: url(${ talentMuseum.about_image });`"></div>
                </div>
                <div class="text_group">
                    <p class="name">{{ talentMuseum.about_name }}</p>
                    <p class="desc" v-html="$textToHtml(talentMuseum.about_desc)"></p>
                </div>
            </div>
            <!-- 计划 -->
            <div class="content plan flex align_center">
                <div class="text_group">
                    <p class="name">{{ talentMuseum.plan_name }}</p>
                    <p class="desc" v-html="$textToHtml(talentMuseum.plan_desc)"></p>
                </div>
                <div class="cover">
                    <div class="layout_bg bg" :style="`background-image: url(${ talentMuseum.plan_image });`"></div>
                    <p class="tip">{{ talentMuseum.plan_image_name }}</p>
                </div>
            </div>
            <!-- 案例 -->
            <div class="content" v-if="talentMuseum.case_list.length > 0">
                <div class="list flex flex_wrap">
                    <a class="item" v-for="(item, index) in talentMuseum.case_list" :key="index" :href="item.link" target="_blank">
                        <div class="layout_bg cover" :style="`background-image: url(${ item.image });`"></div>
                        <p class="name">{{ item.name }}</p>
                    </a>
                </div>
                <div class="flex justify_end" v-if="talentMuseum.case_more">
                    <a class="layout_btn_more" :href="talentMuseum.case_more" target="_blank">了解更多</a>
                </div>
            </div>
            <!-- 奖项 -->
            <div class="content awards flex align_center">
                <div class="cover">
                    <div class="layout_bg bg" :style="`background-image: url(${ talentMuseum.awards_image });`"></div>
                </div>
                <div class="text_group">
                    <p class="name" v-html="$textToHtml(talentMuseum.awards_name)"></p>
                    <p class="desc" v-html="$textToHtml(talentMuseum.awards_desc)"></p>
                </div>
            </div>
        </div>
        <ContactForm from="人才"/>
    </div>
</template>

<style scoped lang="scss">
.museum{
    @media only screen and (max-width: 750px) {
        .layout_main{
            width: 100%;
        }
    }
}
.content{
    margin-bottom: .4rem;
}
.text_group{
    flex: 1;
    font-size: .18rem;
    padding: 0 2em;
    .name{
        font-size: .26rem;
        text-align: center;
        margin-bottom: .2rem;
    }
    .desc{
        line-height: 2;
        text-align: justify;
    }
    @media only screen and (max-width: 750px) {
        font-size: .28rem;
        padding: .3rem;
        .name{
            font-size: .36rem;
        }
        .desc{
            line-height: 1.8;
        }
    }
}
.banner{
    height: 3.85rem;
    position: relative;
    .bg{
        position: absolute;
    }
    .text{
        position: absolute;
        top: 50%;
        left: 1rem;
        transform: translate(0, -50%);
        color: #fff;
        .name{
            font-size: .4rem;
        }
        .en_name{
            font-size: .24rem;
        }
    }
    @media only screen and (max-width: 750px) {
        height: 8.5rem;
        margin-bottom: 0;
        .text{
            top: auto;
            left: 0;
            bottom: 1.2rem;
            width: 100%;
            text-align: center;
            transform: translate(0, 0);
            .name{
                font-size: .36rem;
            }
            .en_name{
                font-size: .26rem;
            }
        }
    }
}
.about{
    .cover{
        width: 4.2rem;
        height: 4.2rem;
    }
    @media only screen and (max-width: 750px) {
        .cover{
            display: none;
        }
    }
}
.plan{
    .cover{
        .tip{
            font-size: .16rem;
            color: #999;
            text-align: center;
            line-height: 2;
        }
        .bg{
            width: 6.8rem;
            height: 3.4rem;
        }
    }
    @media only screen and (max-width: 750px) {
        flex-direction: column-reverse;
        .cover{
            width: 100%;
            .tip{
                font-size: .2rem;
            }
            .bg{
                width: 100%;
                height: 8.5rem;
            }
        }
        .text_group{
            .name{
                font-size: .3rem;
            }
        }
    }
}
.list{
    gap: .3rem;
    .item{
        width: 3.8rem;
        .cover{
            height: 0;
            padding-bottom: 100%;
        }
        .name{
            font-size: .18rem;
            text-align: center;
            margin-top: .2rem;
        }
    }
    @media only screen and (max-width: 750px) {
        padding: 0 .3rem;
        .item{
            width: 3.3rem;
            .name{
                font-size: .26rem;
            }
        }
        &+.flex{
            justify-content: center;
        }
    }
}
.awards{
    .cover{
        width: 3.9rem;
        height: 3.56rem;
    }
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        .cover{
            width: 100%;
            height: 8.5rem;
        }
    }
}
</style>